import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import DoctorCard from "./DoctorCard/DoctorCard";
import FindDoctorSearch from "./FindDoctorSearch/FindDoctorSearch";
import "./BookingConsultation.css";

const BookingConsultation = () => {
  const [searchParams] = useSearchParams();
  const [doctors, setDoctors] = useState([]);
  const [filteredDoctors, setFilteredDoctors] = useState([]);
  const [isSearched, setIsSearched] = useState(false);
  const navigate = useNavigate();

  const getDoctorsDetails = () => {
    fetch("https://api.npoint.io/9a5543d36f1460da2f63")
      .then((res) => res.json())
      .then((data) => {
        if (searchParams.get("speciality")) {
          const filtered = data.filter(
            (doctor) =>
              doctor.speciality.toLowerCase() ===
              searchParams.get("speciality").toLowerCase()
          );
          setFilteredDoctors(filtered);
          setIsSearched(true);
        } else {
          setFilteredDoctors([]);
          setIsSearched(false);
        }
        setDoctors(data);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    getDoctorsDetails();
    const authtoken = sessionStorage.getItem("auth-token");
    if (!authtoken) {
      navigate("/login");
    }
  }, [searchParams, navigate]);

  return (
    <div className="searchpage-container">
      <FindDoctorSearch />
      <div className="search-results-container">
        {isSearched && (
          <>
            <h2>{filteredDoctors.length} doctors available</h2>
            <h3>Book with minimum wait-time and verified doctor details</h3>
            {filteredDoctors.length > 0 ? (
              <div className="doctors-grid">
                {filteredDoctors.map((doctor) => (
                  <DoctorCard {...doctor} key={doctor.name} />
                ))}
              </div>
            ) : (
              <p>No doctors found for this specialty.</p>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default BookingConsultation;
